module.exports = __webpack_public_path__ + "img/concept-multi-agent.4f7e79e5.svg";